import NeoFinancialIcon from '../../assets/icons/neofinancial_icon.svg';
import WillfulIcon from '../../assets/icons/willful_icon.svg';
import PolicyMeEnIcon from '../../assets/icons/policyme_en.svg';
import PolicyMeFrIcon from '../../assets/icons/policyme_fr.svg';
import YouthfullyIcon from '../../assets/icons/youthfully_icon.svg';
import ApolloIcon from '../../assets/icons/apollo_icon.svg';
import CslIcon from '../../assets/icons/csl_icon.svg';

const exclusiveOffers = {
  apollo: {
    id: 'apollo',
    componentName: 'Apollo',
    title: 'exclusiveOffers.apollo.title',
    message: 'exclusiveOffers.apollo.message',
    url: 'exclusiveOffers.apollo.url',
    icon: {
      'en-US': ApolloIcon,
      'fr-CA': ApolloIcon
    },
    iconAlt: 'exclusiveOffers.apollo.alt'
  },
  csl: {
    id: 'csl',
    componentName: 'CSL',
    title: 'exclusiveOffers.csl.title',
    message: 'exclusiveOffers.csl.message',
    url: 'exclusiveOffers.csl.url',
    icon: {
      'en-US': CslIcon,
      'fr-CA': CslIcon
    },
    iconAlt: 'exclusiveOffers.csl.alt'
  },
  policyMe: {
    id: 'policyMe',
    componentName: 'PolicyMe',
    title: 'exclusiveOffers.policyMe.title',
    message: 'exclusiveOffers.policyMe.message',
    url: 'exclusiveOffers.policyMe.url',
    icon: {
      'en-US': PolicyMeEnIcon,
      'fr-CA': PolicyMeFrIcon
    },
    iconAlt: 'exclusiveOffers.policyMe.alt'
  },
  neoFinancial: {
    id: 'neoFinancial',
    componentName: 'NeoFinancial',
    title: 'exclusiveOffers.neoFinancial.title',
    message: 'exclusiveOffers.neoFinancial.message',
    url: 'exclusiveOffers.neoFinancial.url',
    icon: {
      'en-US': NeoFinancialIcon,
      'fr-CA': NeoFinancialIcon
    },
    iconAlt: 'exclusiveOffers.neoFinancial.alt'
  },
  willful: {
    id: 'willful',
    componentName: 'Willful',
    title: 'exclusiveOffers.willful.title',
    message: 'exclusiveOffers.willful.message',
    url: 'exclusiveOffers.willful.url',
    icon: {
      'en-US': WillfulIcon,
      'fr-CA': WillfulIcon
    },
    iconAlt: 'exclusiveOffers.willful.alt'
  },
  youthfully: {
    id: 'youthfully',
    componentName: 'Youthfully',
    title: 'exclusiveOffers.youthfully.title',
    message: 'exclusiveOffers.youthfully.message',
    url: 'exclusiveOffers.youthfully.url',
    icon: {
      'en-US': YouthfullyIcon,
      'fr-CA': YouthfullyIcon
    },
    iconAlt: 'exclusiveOffers.youthfully.alt'
  },
  // TODO: Replace versions 2 when we dont use the offers in the old format anymore
  policyMe2: {
    id: 'policyMe',
    componentName: 'PolicyMe',
    title: 'exclusiveOffers.policyMe2.title',
    message: 'exclusiveOffers.policyMe2.message',
    url: 'exclusiveOffers.policyMe2.url',
    icon: {
      'en-US': PolicyMeEnIcon,
      'fr-CA': PolicyMeFrIcon
    },
    iconAlt: 'exclusiveOffers.policyMe2.alt',
    logEvent: {
      eventName: 'PACSuccess',
      eventCode: 'PACSuccessPage_OnClickPolicyMe'
    }
  },
  willful2: {
    id: 'willful',
    componentName: 'Willful',
    title: 'exclusiveOffers.willful2.title',
    message: 'exclusiveOffers.willful2.message',
    url: 'exclusiveOffers.willful2.url',
    icon: {
      'en-US': WillfulIcon,
      'fr-CA': WillfulIcon
    },
    iconAlt: 'exclusiveOffers.willful.alt',
    logEvent: {
      eventName: 'PACSuccess',
      eventCode: 'PACSuccessPage_OnClickWillful'
    }
  },
  apollo2: {
    id: 'apollo',
    componentName: 'Apollo',
    title: 'exclusiveOffers.apollo2.title',
    message: 'exclusiveOffers.apollo2.message',
    url: 'exclusiveOffers.apollo2.url',
    icon: {
      'en-US': ApolloIcon,
      'fr-CA': ApolloIcon
    },
    iconAlt: 'exclusiveOffers.apollo.alt'
  }
};

export const getExclusiveOfferOptions = (exclusiveOfferIds) => {
  // Set default options if no exclusiveOfferIds found
  let exclusiveOfferOptions = [
    exclusiveOffers.policyMe,
    exclusiveOffers.neoFinancial,
    exclusiveOffers.willful,
    exclusiveOffers.youthfully,
    exclusiveOffers.policyMe2,
    exclusiveOffers.willful2,
    exclusiveOffers.apollo2
  ];

  if (exclusiveOfferIds && Array.isArray(exclusiveOfferIds)) {
    exclusiveOfferOptions = [];

    // For any found data using id, push to final options list
    exclusiveOfferIds.forEach((offerKey) => {
      if (exclusiveOffers[offerKey]) {
        exclusiveOfferOptions.push(exclusiveOffers[offerKey]);
      }
    });
  }

  return exclusiveOfferOptions;
};
